<template lang="pug">
section#membership.section.page-section
  spinner(v-if="settings.loading")
  div(v-else)
    .membership-bylaws.membership-block
      .container.mobile-padding
        img(src="/images/cwo/bylaws.png")
        .content
          h1.is-size-2-desktop.is-size-3-touch.is-uppercase Becoming a member
          p.is-size-5 At Cornerstone, we believe that Jesus Christ &ldquo;is the head of the church&rdquo; (Colossians 1:18), and so we take church membership very seriously.
          p.is-size-5 Becoming a member of Cornerstone requires affirming and abiding by the church&rsquo;s <i>Bylaws</i>&mdash;a comprehensive, Biblical faith statement that summarizes our belief in Christ and our commitment to Him and each other.
          p.is-size-5 You can download a digital copy of the <i>Bylaws</i> below or request a physical copy by <a :href="`mailto:${account.email}`">contacting</a> the church office.
          .buttons
            b-button(
              size="is-medium"
              type="is-primary"
              v-scroll-to="{ el: '#covenant', offset: -100 }"
            ) Renew the Covenant
            b-button(
              tag="a"
              type="is-light"
              size="is-medium"
              href="https://cornerstoneworldoutreach.s3.us-east-2.amazonaws.com/cornerstone-bylaws-2017.pdf"
            ) Read the Bylaws
    .membership-photos.membership-block
      .container
        b-carousel-list(
          v-model="listItem"
          :data="images"
          :items-to-list="3"
          :items-to-show="3"
          repeat
        )
          template(slot="item" slot-scope="props")
            figure.is-16by9.membership-photo
              img(:src="props.list.image")
    #covenant.membership-form.membership-block
      .container.mobile-padding
        .content.has-text-centered
          h2.is-size-2-desktop.is-size-3-touch.is-uppercase.is-title Renew the covenant
          p.is-size-5 As a sign of faithfulness to Christ and His church, Cornerstone members renew their covenant commitment each year.
        .box
          img.logo(src="/images/cwo/cwo-crest.png")
          form(@submit.prevent="submit" novalidate)
            b-field(
              label="Full Name"
              :type="errors.has('name') ? 'is-danger' : ''"
              :message="errors.has('name') ? errors.first('name') : ''"
            )
              b-input(
                name="name"
                v-validate="'required'"
                :value="commitment.name"
                @input="set($event, 'name')"
              )
            b-field(
              label="Email Address"
              :type="errors.has('email') ? 'is-danger' : ''"
              :message="errors.has('email') ? errors.first('email') : ''"
            )
              b-input(
                name="email"
                v-validate="'required|email'"
                :value="commitment.email"
                @input="set($event, 'email')"
              )
            b-field(
              :type="errors.has('agreed') ? 'is-danger' : ''"
              :message="errors.has('agreed') ? errors.first('agreed') : ''"
            )
              b-checkbox(
                data-vv-as="commitment"
                data-vv-name="agreed"
                name="agreed"
                v-validate="'required:true'"
                :value="commitment.agreed"
                @input="set($event, 'agreed')"
              ) I reaffirm my commitment to the Biblical standards expressed in the <i>Bylaws</i> of Cornerstone
            b-button(
              native-type="submit"
              type="is-primary"
              size="is-medium"
              :loading="settings.submitting"
            ) Submit for {{ year }}
    .membership-episodes.membership-block(v-if="episodes.length > 0")
      .container
        .content.has-text-centered
          h2.is-size-2-desktop.is-size-3-touch.is-uppercase.is-title Go deeper
          p.is-size-5 Study the <i>Bylaws</i> line-by-line with Cornerstone World Outreach&rsquo;s senior pastor, Cary Gordon.
        .columns.is-multiline
          .column.is-one-quarter(
            v-for="episode in episodes"
            :key="episode.id"
          )
            episode-list-item(
              :value="episode"
              hoverable
            )
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import EpisodeListItem from '@/components/episodes/EpisodeListItem.vue';
import EventForm from '@/components/events/EventForm.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'membership',
  components: {
    EpisodeListItem,
    EventForm,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      commitment: getterTypes.GET_COMMITMENT,
      episodes: getterTypes.GET_EPISODES,
    }),
    episodesQuery() {
      const today = moment().format('YYYY-MM-DD');
      const from = this.pagination.per * (this.pagination.page - 1);
      const payload = {
        from,
        size: this.pagination.per,
        sort: [
          { pub_date: 'asc' },
        ],
        query: {
          bool: {
            must: [
              { terms: { collection_ids: [this.account.membership_collection_id] } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: today } } },
            ],
          },
        },
      };
      return payload;
    },
    morePages() {
      if (this.pagination.total === 0) return false;
      return Math.ceil(this.pagination.total / this.pagination.per) > this.pagination.page;
    },
    year() {
      const date = new Date();
      return date.getFullYear();
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      bottom: false,
      images: [
        {
          image: '/images/cwo/membership02.jpg',
          title: 'Photo 1',
        },
        {
          image: '/images/cwo/membership04.jpg',
          title: 'Photo 2',
        },
        {
          image: '/images/cwo/membership05.jpg',
          title: 'Photo 3',
        },
        {
          image: '/images/cwo/membership03.jpg',
          title: 'Photo 1',
        },
        {
          image: '/images/cwo/membership01.jpg',
          title: 'Photo 2',
        },
        {
          image: '/images/cwo/membership06.jpg',
          title: 'Photo 3',
        },
        {
          image: '/images/cwo/membership07.jpg',
          title: 'Photo 1',
        },
        {
          image: '/images/cwo/membership08.jpg',
          title: 'Photo 2',
        },
        {
          image: '/images/cwo/membership09.jpg',
          title: 'Photo 3',
        },
      ],
      listItem: 0,
      pagination: {
        page: 1,
        per: 12,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    async getEpisodesPage(page, opts) {
      this.pagination.page = page;
      const payload = Object.assign({}, (opts || {}), this.episodesQuery);
      const response = await this.$store.dispatch(actionTypes.DO_GET_EPISODES, payload);
      this.pagination.total = response.hits.total;
    },
    // async getEvent() {
    //   const payload = {
    //     id: this.account.membership_collection_id,
    //     zoom: 'artwork,collections,contact,form,events,instances,location,ministries,packages,related',
    //   };
    //   await this.$store.dispatch(actionTypes.DO_GET_EVENT, payload);
    // },
    async init() {
      this.settings.loading = true;
      this.$store.commit(mutationTypes.SET_EPISODES, []);
      if (this.account.membership_collection_id) {
        await this.getEpisodesPage(1);
      }
      this.settings.loading = false;
    },
    scrollHandler() {
      const y = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const adjustedHeight = pageHeight - 300;
      const bottomOfPage = visible + y >= adjustedHeight;
      this.bottom = bottomOfPage || adjustedHeight < visible;
    },
    set(val, key) {
      this.$store.commit(mutationTypes.SET_COMMITMENT_FIELD, {
        key,
        val,
      });
    },
    async submit() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const payload = {
          email: this.commitment.email,
          name: this.commitment.name,
        };
        try {
          const response = await this.$store.dispatch(actionTypes.DO_CREATE_COMMITMENT, payload);
          this.$buefy.dialog.alert({
            title: 'Success',
            message: response.message,
          });
        } catch (error) {
          this.$buefy.dialog.alert({
            title: 'Error',
            message: error.response.data.data.error_message,
            type: 'is-danger',
            hasIcon: true,
          });
        } finally {
          this.$store.commit(mutationTypes.SET_COMMITMENT, {});
          this.$validator.reset();
          this.settings.submitting = false;
        }
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  watch: {
    bottom(val) {
      if (val && this.morePages) {
        this.getEpisodesPage(this.pagination.page + 1, { method: 'append' });
      }
    },
    $route(to, from) {
      if (to.params.id !== from.params.id) this.init();
    },
  },
};
</script>

<style lang="scss">
#membership {
  padding-top: 0 !important;
  .membership-block + .membership-block {
    margin-top: 2.5rem;
  }
  .membership-block-wrapper {
    margin: 0 auto;
  }
  .membership-bylaws {
    background-size: cover;
    display: flex;
    .container {
      display: flex;
      align-items: center;
      .button {
        font-family: $body-font;
      }
    }
  }
  .membership-photos {
    .carousel-list {
      box-shadow: none;
    }
    .membership-photo {
      img {
        border-radius: 4px;
        // box-shadow: 0 0 30px rgba(0,0,0,0.1);
      }
    }
  }
  .membership-form {
    .box {
      background-color: $white;
      border-radius: 4px;
      box-shadow: 0 0 30px rgba(0,0,0,0.05);
      border: none;
      .logo {
        width: 120px;
        margin: 0 auto 1rem auto;
        display: block;
      }
    }
  }
  .membership-episodes {
    margin-bottom: 5rem;
    .content {
      margin-bottom: 3rem;
    }
  }

  @media (max-width: $tablet) {
    .membership-bylaws {
      background-image: url('/images/cwo/membership-bg-mobile.jpg');
      background-size: contain;
      background-repeat: no-repeat;
      .container {
        flex-flow: column;
        text-align: center;
        img {
          max-width: 280px;
        }
        .buttons {
          justify-content: center;
          margin-bottom: 1.75rem;
          .button.is-light {
            // background-color: rgba(255,255,255, 0.25);
          }
        }
      }
    }
    .membership-form {
      .box {
        padding-bottom: 1.75rem;
        .button[type="submit"] {
          width: 100%;
        }
      }
    }
  }

  @media (min-width: $tablet) {
    .membership-block + .membership-block {
      margin-top: 5rem;
    }
    .membership-bylaws {
      height: calc(100vh - 72px);
      background-image: url('/images/cwo/membership-bg.jpg');
      img {
        max-width: 500px;
      }
    }
    .membership-photos {
      .membership-photo {
        padding: 0 0.75rem;
      }
    }
    .membership-form {
      .box {
        .logo {
          width: 180px;
          margin-bottom: 2.5rem;
        }
        padding: 3rem;
        max-width: 60%;
        margin: 0 auto;
      }
    }
  }
}
</style>
